module.exports = __webpack_public_path__ + "static/media/3-search-scene.baa29bb0.mp4";